import { render, staticRenderFns } from "./BestBet.vue?vue&type=template&id=5acdae72&scoped=true"
import script from "./BestBet.vue?vue&type=script&lang=js"
export * from "./BestBet.vue?vue&type=script&lang=js"
import style0 from "./BestBet.vue?vue&type=style&index=0&id=5acdae72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acdae72",
  null
  
)

export default component.exports